import React, { useEffect, useReducer, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import Grid from "@mui/material/Grid2";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import BASEURL from "../../../pages/Utils/Baseurl";
import { allBrands } from "../brand/brandData";
import { allProductCategories } from "../productCategory/productCategoryData";
import request from "graphql-request";
import MaterialSelect from "../../../components/MasterSelect";
import {
  allProductsDropdown,
  createtodayproduct,
  todayProductData,
  todayProductDataMange,
  updatetodayproduct,
} from "./todayProductData";
import MaterialButton from "../../../components/MaterialButton";
import ImageSelector from "../../components/ImageSelector";
import { useMutation } from "@apollo/client";
import Swal from "sweetalert2";
import { useLoading } from "../../../context/LodingContext";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import { allProducts } from "../productMaster/productData";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

const TodayProductForm = () => {
  const [todayProduct, dispatch] = useReducer(
    todayProductDataMange,
    todayProductData
  );
  const [brandLoading, setBrandLoading] = useState(false);
  const [catgoreyLoading, setCatgoreyLoading] = useState(false);
  const [inputDisble, setInputDisble] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [productBrandOption, setProductBrandOption] = useState([]);
  const [productcategoryOption, setProductcategoryOption] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const [createToday, { loading, error }] = useMutation(createtodayproduct);
  const [UpdateBrand] = useMutation(updatetodayproduct);
  const formType = location?.state?.type;
  const formValue = location?.state?.data;
  const { userId } = useAuthData();
  const [itemCodeOption, setItemCodeOption] = useState([]);
  const [itemcodeLoding, setItemCodeLoading] = useState(false);

  
  
  useEffect(() => {
    if (formValue) {
      dispatch({
        value: { value: formValue?.productCode, label: formValue?.productCode },
        name: "productCode",
      });
      dispatch({
        value: formValue?.productName,
        name: "productName",
      });
      dispatch({
        value: formValue?.productCategory,
        name: "productCategory",
      });
      dispatch({
        value: formValue?.productBrand,
        name: "productBrand",
      });
      dispatch({
        value: formValue?.productBrandCode,
        name: "productBrandCode",
      });
      dispatch({
        value: formValue?.vat,
        name: "vat",
      });
      dispatch({
        value: formValue?.baseUom,
        name: "baseUom",
      });
      dispatch({
        value: formValue?.productUom,
        name: "productUom",
      });
      dispatch({
        value: formValue?.conversion,
        name: "conversion",
      });
      dispatch({
        value: formValue?.currentStock,
        name: "currentstock",
      });
      dispatch({
        value: formValue?.stockInCtn,
        name: "stockInPart",
      });
      dispatch({
        value: formValue?.stockInPart,
        name: "pcs",
      });
      dispatch({
        value: formValue?.productImage,
        name: "productImage",
      });
    }
  }, [formValue]);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);
  useEffect(() => {
    fetchdata();
    fetchCategorydata();
    fetchProductCodedata();
  }, []);
  const fetchdata = () => {
    setBrandLoading(true);
    request(BASEURL, allBrands)
      .then((res) => {
        const success = res?.allBrands?.success;
        const message = res?.allBrands?.message;
        if (success) {
          setProductBrandOption(res?.allBrands?.data);
        } else {
          Swal.fire({
            position: "top",
            icon: "error",
            title: message,
            showConfirmButton: true,
          });
          setProductBrandOption([]);
        }
      })

      .finally(() => {
        setBrandLoading(false);
      });
  };

  const fetchProductCodedata = () => {
    setItemCodeLoading(true);
    request(BASEURL, allProductsDropdown)
      .then((res) => {
        // const success = res?.allProducts?.success;
        // const message = res?.allProducts?.message;

        setItemCodeOption(res?.allProductsDropdown?.data);
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
      })
      .finally(() => {
        setItemCodeLoading(false);
      });
  };
  const fetchCategorydata = () => {
    setCatgoreyLoading(true);

    request(BASEURL, allProductCategories)
      .then((res) => {
        const success = res?.allProductCategories?.success;
        const message = res?.allProductCategories?.message;
        if (success) {
          setProductcategoryOption(res?.allProductCategories?.data);
        } else {
          setProductcategoryOption([]);
        }
      })

      .finally(() => {
        setCatgoreyLoading(false);
      });
  };
  const handleImageSelect = (file) => {
    dispatch({ value: file, name: "productImage" });
  };
  const handleAdd = async () => {
    const data = {
      userId: userId,
      productCode: todayProduct?.productCode?.label,
      productName: todayProduct?.productName,
      productCategory: todayProduct?.productCategory,
      productBrand: todayProduct?.productBrand,
      productBrandCode: todayProduct?.productBrandCode,
      productUom: todayProduct?.productUom,
      baseUom: todayProduct?.baseUom,
      conversion: todayProduct?.conversion,
      vat: todayProduct?.vat,
      currentStock: todayProduct?.currentstock,
      stockInCtn: todayProduct?.stockInPart,
      stockInPart: todayProduct?.pcs,
      productImage: todayProduct?.productImage,
    };

    setCirleLoading(true);
    try {
      const response = await createToday({
        variables: {
          input: data,
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.createTodayProduct?.success;

      const message = response?.data?.createTodayProduct?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/todays-products");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      const message =
        err?.response?.errors?.[0]?.message ||
        err?.message ||
        "Something went wrong";
      Swal.fire({
        position: "top",
        icon: "error",
        title: message,
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };
  const handleUpdateBrand = async () => {
    setCirleLoading(true);

    try {
      const response = await UpdateBrand({
        variables: {
          input: {
            productId: formValue?.id,
            productCode: todayProduct?.productCode?.label,
            productName: todayProduct?.productName,
            productCategory: todayProduct?.productCategory,
            productBrand: todayProduct?.productBrand,
            productBrandCode: todayProduct?.productBrandCode,
            productUom: todayProduct?.productUom,
            baseUom: todayProduct?.baseUom,
            conversion: todayProduct?.conversion,
            vat: todayProduct?.vat,
            currentStock: todayProduct?.addcurrentstock || 0,
            stockInCtn: todayProduct?.addstockInPart || 0,
            stockInPart: todayProduct?.addpcs || 0,
            productImage: todayProduct?.productImage?.name
              ? todayProduct?.productImage
              : null,
          },
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.updateTodayProduct?.success;

      const message = response?.data?.updateTodayProduct?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/todays-products");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      todayProduct.productCodeStatus === "success" &&
      todayProduct.productNameStatus === "success" &&
      todayProduct.productCategoryStatus === "success" &&
      todayProduct.productBrandStatus === "success" &&
      todayProduct.productUomStatus === "success" &&
      todayProduct.baseUomStatus === "success" &&
      todayProduct.conversionStatus === "success" &&
      todayProduct.currentstockStatus === "success" &&
      todayProduct.stockInPartStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleProductCodeChange = (e, s) => {
    if (e) {
      const fileterdata = itemCodeOption?.filter((v, i) => {
        if (v?.productCode == e?.label) {
          dispatch({ value: v?.productName, name: "productName" });
          dispatch({ value: v?.productCategory, name: "productCategory" });
          dispatch({ value: v?.productBrand, name: "productBrand" });
          dispatch({ value: v?.productBrandCode, name: "productBrandCode" });
          dispatch({ value: v?.conversion, name: "conversion" });
          dispatch({ value: v?.vat, name: "vat" });
          dispatch({ value: v?.productUom, name: "productUom" });
          dispatch({ value: v?.baseUom, name: "baseUom" });
        }
      });
    }
    dispatch({ value: e, name: s?.name });
  };

  const handleDownload = async () => {
    const imageUrl = formValue?.productImage;
    if (!imageUrl) return;

    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "todaysproduct_image.jpg";
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <DashboardLayout>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="md"
      >
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden", // prevent scrollbars
            p: 0,
          }}
        >
          {ImageSelector ? (
            <img
              src={formValue?.productImage}
              alt="Image"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: "8px",
                objectFit: "contain",
                display: "block",
              }}
            />
          ) : (
            <MaterialTypography>No image available</MaterialTypography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Close</Button>
          {formType == "view" ? (
            <Button onClick={handleDownload}>Download</Button>
          ) : (
            ""
          )}
        </DialogActions>
      </Dialog>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Today Product Details"
                    : formType == "edit"
                    ? "Edit Today Product Details"
                    : "View Today Product Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Today Product Information
            </MaterialTypography>
          </Stack>

          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Item Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialSelect
                  name="productCode"
                  value={todayProduct?.productCode}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={itemCodeOption?.map((item) => {
                    return {
                      value: item?.productCode,
                      label: item?.productCode,
                    };
                  })}
                  onChange={(e, s) => handleProductCodeChange(e, s)}
                  error={
                    todayProduct.productCodeStatus === "error" ? true : false
                  }
                  success={
                    todayProduct.productCodeStatus === "success" ? true : false
                  }
                  isLoading={itemcodeLoding}
                  isClearable
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Item Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={todayProduct?.productName}
                  name="productName"
                  placeholder="Enter Product Name"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productName" })
                  }
                  error={
                    todayProduct.productNameStatus === "error" ? true : false
                  }
                  success={
                    todayProduct.productNameStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Category Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  value={todayProduct?.productCategory}
                  name="productCategory"
                  placeholder="Enter Product Code"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productName" })
                  }
                  error={
                    todayProduct.productCategoryStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    todayProduct.productCategoryStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Item Brand <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  value={todayProduct?.productBrand}
                  name="productBrand"
                  placeholder="Enter Item Brand"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productName" })
                  }
                  error={
                    todayProduct.productBrandStatus === "error" ? true : false
                  }
                  success={
                    todayProduct.productBrandStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Brand Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  value={todayProduct?.productBrandCode}
                  name="productBrandCode"
                  placeholder="Enter Brand Code"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productName" })
                  }
                  error={
                    todayProduct.productBrandCodeStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    todayProduct.productBrandCodeStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    VAT <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={todayProduct?.vat}
                  name="vat"
                  placeholder="Enter VAT"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productUom" })
                  }
                  error={todayProduct.vatStatus === "error" ? true : false}
                  success={todayProduct.vatStatus === "success" ? true : false}
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    UOM <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={todayProduct?.productUom}
                  name="productUom"
                  placeholder="Enter UOM"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productUom" })
                  }
                  error={
                    todayProduct.productUomStatus === "error" ? true : false
                  }
                  success={
                    todayProduct.productUomStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Least UOM <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={todayProduct?.baseUom}
                  name="baseUom"
                  placeholder="Enter Base UOM"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "baseUom" })
                  }
                  error={todayProduct.baseUomStatus === "error" ? true : false}
                  success={
                    todayProduct.baseUomStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Conversion <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={todayProduct?.conversion}
                  name="conversion"
                  placeholder="Enter Conversion"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "conversion" })
                  }
                  error={
                    todayProduct.conversionStatus === "error" ? true : false
                  }
                  success={
                    todayProduct.conversionStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    STOCK IN LEAST QTY <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={todayProduct?.currentstock}
                  name="currentstock"
                  placeholder="Enter Current stock"
                  disabled={formType == "edit" ? true : inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "currentstock" })
                  }
                  error={
                    todayProduct.currentstockStatus === "error" ? true : false
                  }
                  success={
                    todayProduct.currentstockStatus === "success" ? true : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    STOCK IN UOM <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={todayProduct?.stockInPart}
                  name="stockInPart"
                  placeholder="Enter Stock In Part"
                  disabled={formType == "edit" ? true : inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "stockInPart" })
                  }
                  error={
                    todayProduct.stockInPartStatus === "error" ? true : false
                  }
                  success={
                    todayProduct.stockInPartStatus === "success" ? true : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    STOCK IN LEAST UOM <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={todayProduct?.pcs}
                  name="pcs"
                  placeholder="Enter PCS"
                  disabled={formType == "edit" ? true : inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "pcs" })
                  }
                  error={todayProduct.pcsStatus === "error" ? true : false}
                  success={todayProduct.pcsStatus === "success" ? true : false}
                />
              </Grid>
              {formType != "add" && (
                <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Sold Stock <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    value={formValue?.soldStock}
                    name="pcs"
                    placeholder="Enter PCS"
                    disabled={formType == "edit" ? true : inputDisble}
                    onChange={(e) =>
                      dispatch({ value: e?.target?.value, name: "pcs" })
                    }
                    error={todayProduct.pcsStatus === "error" ? true : false}
                    success={formValue?.soldStock ? true : true}
                  />
                </Grid>
              )}

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Image
                  </MaterialTypography>
                </MaterialBox>

                <FullscreenIcon
                  fontSize="small"
                  className="viewIcon"
                  onClick={() => {
                    setDialogOpen(true);
                  }}
                  style={{
                    cursor: "pointer",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                />

                <ImageSelector
                  onImageSelect={handleImageSelect}
                  imageUrl={formValue?.productImage}
                  disabled={inputDisble}
                />
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/todays-products")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={formType == "add" ? handleAdd : handleUpdateBrand}
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default TodayProductForm;
